import { Hash } from 'fast-sha256';

/** File integrity checks must also work on local HTTP (no SubtleCrypto). */
export async function sha256Bytes(bytes: ArrayBuffer): Promise<string> {
  const subtle = globalThis.crypto?.subtle;
  let digest: Uint8Array;
  if (subtle) {
    digest = new Uint8Array(await subtle.digest('SHA-256', bytes));
  } else {
    const hash = new Hash();
    const data = new Uint8Array(bytes);
    const chunkSize = 1024 * 1024;
    try {
      for (let offset = 0; offset < data.length; offset += chunkSize) {
        hash.update(data.subarray(offset, offset + chunkSize));
        // Keep upload progress responsive when hashing larger lectures in JS.
        if (offset + chunkSize < data.length) await new Promise(resolve => setTimeout(resolve, 0));
      }
      digest = hash.digest();
    } finally {
      hash.clean();
    }
  }
  return Array.from(digest, value => value.toString(16).padStart(2, '0')).join('');
}
